export enum USER_ROLES {
  OWNER = 'owner',
  MANAGER = 'manager',
  LEADER = 'leader',
  CASHIER = 'cashier',
}
